module.exports = __webpack_public_path__ + "static/media/a2.58a2fe05.jpg";